import axios from 'axios';

export type JwtToken = {
  email: string;
  iat: number;
  exp: number;
};

export type HttpError =
  | null
  | string
  | Array<{ [key: string]: string }>
  | Array<{ field: string; message: string }>;

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const selectedLocale = localStorage.getItem('selectedLocale');
  const selectedBranch = localStorage.getItem('selectedBranch');

  if (selectedLocale && config.headers) {
    config.headers = {
      ...config.headers,
      selectedLocale,
    };
  }

  if (selectedBranch && config.headers) {
    config.headers = {
      ...config.headers,
      branch: selectedBranch,
    };
  }

  if (token && config.headers) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 413) {
      error.response['data'] = {
        statusCode: 413,
        message: 'File too large (max 2MB)',
        error: 'Payload Too Large',
      };
    }

    return Promise.reject(error);
  },
);

export default instance;
